import type { ConversationUser } from '@/types/data'
import { OrderStatusBadge } from '../pages/medication-request/sections/previous-orders'
import { htmlUnescape } from '@/lib/utils'

const dateOption = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  hour12: true
})

type Props = {
  message: string
  createdAt?: Date
  attachments?: string[]
  isOwnMessage: boolean
  isUnread?: boolean
  from?: ConversationUser
  onAttachmentClick?: (attachment: string) => void
  isCS?: boolean
}

const Message = ({
  isUnread = false,
  isOwnMessage,
  message,
  createdAt,
  from,
  attachments,
  onAttachmentClick,
  isCS
}: Props) => {
  const showUnreadStyle = !isOwnMessage && isUnread

  const timestamp = dateOption.format(new Date(createdAt ?? new Date()))

  return (
    <div className={`${isOwnMessage ? 'pl-0' : 'pl-3'} ${isCS ? 'mb-4' : ''}`}>
      <div
        className={`rounded-2xl ${isOwnMessage ? 'bg-[#E4E9FC]' : 'bg-white'} border p-4 ${
          showUnreadStyle ? 'border-[#FF4D1A]' : isOwnMessage ? 'border-custom-gray-3' : 'border-[#E9EAED]'
        }`}
      >
        <div className='flex items-center justify-between mb-1'>
          <div>
            <span className='text-custom-neutral-900 font-semibold leading-[133.4%] mr-2'>{from?.name}</span>
          </div>
          {showUnreadStyle && <OrderStatusBadge stage='New' />}
          {isCS && (
            <span className='bg-[#FAFAFB] rounded-2xl border border-[#24272B] text-custom-neutral-800 text-sm leading-[170%] py-2 px-4'>
              Sent to CS
            </span>
          )}
        </div>
        <p className='text-custom-neutral-800 text-sm leading-[170%] mb-4'>{timestamp}</p>
        <p className='text-custom-neutral-600 text-sm leading-[170%] whitespace-pre-line'>{htmlUnescape(message)}</p>
        <div className='flex items-center gap-[15px] mt-4'>
          {!!attachments?.length &&
            attachments.map((attachment, index) => (
              <div key={index} className='relative border w-[120px] h-[120px] border-gray-100 rounded-lg'>
                <button
                  key={index}
                  type='button'
                  onClick={() => onAttachmentClick?.(attachment)}
                  className='absolute inset-0 rounded-lg bg-contain bg-center bg-no-repeat'
                  style={{ backgroundImage: `url(${attachment})` }}
                  aria-label={`Preview attachment ${attachment}`}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Message
